const FLAG_NAME = 'p24_self_card_guard';
const QUERY_NAME = 'selfcard_guard';

/**
 * Opt-in per browser: `?selfcard_guard=1` turns the owner-card identity guard on, `=0` turns it off.
 * Until it is rolled out to everyone, nobody has it unless they asked for it.
 */
export const isSelfCardGuardEnabled = (search?: string): boolean => {
  try {
    const fromUrl = new URLSearchParams(search ?? (typeof window !== 'undefined' ? window.location.search : '')).get(QUERY_NAME);
    if (fromUrl === '1') window.localStorage.setItem(FLAG_NAME, '1');
    else if (fromUrl === '0') window.localStorage.removeItem(FLAG_NAME);
    return window.localStorage.getItem(FLAG_NAME) === '1';
  } catch {
    return false;
  }
};
